export default __webpack_public_path__ + "static/media/p-orders.ef302ded.png";